<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new icon-upload-bg">
      <i class="fa-solid fa-cloud-arrow-up icon-upload"></i>
    </div>
    <div>
      <h2 class="dialog-title">Upload File</h2>
      <p class="dialog-subtitle">Please select an option</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="uploadForm" class="dialog-form-grid">
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Upload File Using<span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="uploadMethod" placeholder="Select method" [compareWith]="comparatorService.compareById" (valueChange)="onChangeUploadMethod($event)">
          @for( option of uploadMethods; track option ) {
            <mat-option [value]="option">
              {{ option | objectdesc }}
            </mat-option>
          }
        </mat-select>
        @if( uploadForm.get('uploadMethod')?.hasError('required') ) {
          <mat-error>Upload method is required</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- File -->
     @if( uploadForm.get('uploadMethod') != null && uploadForm.get('uploadMethod')?.value.id == 1 ) {
      <file-selector [fileFormControl]="$any(uploadForm.get('file'))" [label]="'Media File'" [required]="true" [multiple]="false" (fileSelected)="onSelectFile($event)"></file-selector>
     }
     @if( uploadForm.get('uploadMethod') != null && uploadForm.get('uploadMethod')?.value.id == 2) {
      <aspera-file-selector [fileFormControl]="$any(uploadForm.get('file'))" [label]="'Media File'" [required]="true" [multiple]="false" (fileSelected)="onSelectFileAspera($event)"></aspera-file-selector>
     }

  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSubmit()" [disabled]="!uploadForm.valid">
    Upload
  </button>
</mat-dialog-actions>
